import { JSX } from 'react';
import {
  mappedGroupScheduleWithoutDate,
  mappedTeacherScheduleWithoutDate,
} from 'entities/types';

import { TableScheduleWithoutDate } from '../../tableScheduleWithoutDate';

export const makeTablesWithoutDate = (
  isGroupSchedule: boolean,
  data: mappedGroupScheduleWithoutDate | mappedTeacherScheduleWithoutDate,
) => {
  const res: JSX.Element[] = [];

  data.forEach((item, index) => {
    res.push(
      <TableScheduleWithoutDate
        isGroupSchedule={isGroupSchedule}
        dataSchedule={item}
        dayNum={index + 1}
        key={item[0] ? item[0].key : index}
      />,
    );
  });

  return res;
};
